import { Api } from '@oneclass/ui-components';

// 取得後端佈版時間 （當心跳包使用）
export const getHeartbeat = async () => {
  const response = await Api.get(`${process.env.REACT_APP_DOMAIN}/api/Test/ShowPerformMonitor`, {}, { timeout: (1000 * 10) });
  return response;
};